/** God billing admin + promotion / coupon UI copy. */
export const billingPromoEn = {
  billingTab: 'Billing',
  pageTitleBilling: 'Billing',
  godBillingKicker: 'Subscriptions, payments and platform fees',
  godBillingTabSubscriptions: 'Subscriptions',
  godBillingTabPlans: 'Packages',
  godBillingTabPromotions: 'Promotions',
  godBillingTabPayments: 'Payments',
  godBillingTabTransactions: 'Transactions',
  godBillingTabEvents: 'Events',
  godConfigBillingMovedHint: 'Packages and promotions are managed under Billing.',
  godPromoKicker: 'Create coupon codes with percent or fixed discounts and a validity window.',
  godPromoList: 'Active catalog',
  godPromoEmpty: 'No promotions yet. Create the first coupon below.',
  godPromoCreate: 'New promotion',
  godPromoEdit: 'Edit promotion',
  godPromoCode: 'Code',
  godPromoKind: 'Discount type',
  godPromoKindPercent: 'Percent off',
  godPromoKindAmount: 'Amount off (USD)',
  godPromoPercent: 'Percent (1–100)',
  godPromoAmount: 'Amount off (USD)',
  godPromoDuration: 'Duration',
  godPromoDuration_once: 'Once',
  godPromoDuration_repeating: 'Repeating',
  godPromoDuration_forever: 'Forever',
  godPromoMonths: 'Months (repeating)',
  godPromoValidUntil: 'Valid until (optional)',
  godPromoMaxRedemptions: 'Max redemptions (optional)',
  godPromoPlans: 'Eligible plans',
  godPromoPlansHint: 'Leave all unchecked to allow every self-serve plan.',
  godPromoNote: 'Internal note',
  godPromoSaved: 'Promotion saved',
  godPromoActive: 'Active',
  godPromoInactive: 'Inactive',
  godPromoActivate: 'Activate',
  godPromoDeactivate: 'Deactivate',
  godPromoRedemptions: 'Uses',
  subscriptionPromoCode: 'Promo code',
  subscriptionPromoPlaceholder: 'SAVE20',
  subscriptionPromoApply: 'Apply',
  subscriptionPromoApplied: 'Discount {discount} · due {total}',
  godBillingAllStatuses: 'All statuses',
  godBillingAllPlans: 'All plans',
  godBillingShowArchived: 'Show archived',
  godBillingHideArchived: 'Hide archived',
  godBillingArchived: 'Archived',
  godBillingNoSubscriptions: 'No subscriptions match these filters',
  godBillingReviewQueue: 'Proofs awaiting review',
  godBillingNoPending: 'No proofs to review',
  godBillingViewProof: 'View proof',
  godBillingReason: 'Reason (required)',
  godBillingReasonRequired: 'A reason is required for this action',
  godBillingApprove: 'Approve',
  godBillingReject: 'Reject',
  godBillingGross: 'Processed',
  godBillingFees: 'Platform fees',
  godBillingCharges: 'Charges',
  godBillingNoCharges: 'No charges in this period',
  godBillingNoEvents: 'No billing events yet',
  godBillingSubscription: 'Subscription',
  godBillingCredit: 'Credit',
  godBillingActions: 'God actions',
  godBillingExtendTrial: 'Extend trial 7 days',
  godBillingSetFounder: 'Mark as founder',
  godBillingUnsetFounder: 'Remove founder',
  godBillingSetExempt: 'Exempt from billing',
  godBillingUnsetExempt: 'Remove exemption',
  godBillingUnassign: 'Remove subscription',
  subscriptionExempt: 'Billing waived — full access',
  godBillingArchive: 'Archive',
  godBillingRestore: 'Restore',
  godConfigTabPlans: 'Packages',
  godBillingPlansKicker: 'Prices, quotas and payout accounts',
  godBillingPlanPrices: 'Monthly price (USD)',
  godBillingCommercial: 'Commercial settings',
  godBillingExtraHouse: 'Extra house (USD)',
  godBillingTrialDays: 'Trial days',
  godBillingFeeBps: 'Platform fee (bps)',
  godBillingEnforcement: 'Enforce plan limits',
  godBillingEnforcementHint: 'Turn on once every banker has a subscription.',
  godBillingManualAccounts: 'Manual payment accounts',
};

export const billingPromoEs = {
  billingTab: 'Facturación',
  pageTitleBilling: 'Facturación',
  godBillingKicker: 'Suscripciones, pagos y comisiones de plataforma',
  godBillingTabSubscriptions: 'Suscripciones',
  godBillingTabPlans: 'Paquetes',
  godBillingTabPromotions: 'Promociones',
  godBillingTabPayments: 'Pagos',
  godBillingTabTransactions: 'Transacciones',
  godBillingTabEvents: 'Eventos',
  godConfigBillingMovedHint: 'Los paquetes y promociones se gestionan en Facturación.',
  godPromoKicker: 'Crea cupones con descuento porcentual o fijo y una ventana de vigencia.',
  godPromoList: 'Catálogo',
  godPromoEmpty: 'Aún no hay promociones. Crea el primer cupón abajo.',
  godPromoCreate: 'Nueva promoción',
  godPromoEdit: 'Editar promoción',
  godPromoCode: 'Código',
  godPromoKind: 'Tipo de descuento',
  godPromoKindPercent: 'Porcentaje',
  godPromoKindAmount: 'Monto fijo (USD)',
  godPromoPercent: 'Porcentaje (1–100)',
  godPromoAmount: 'Monto de descuento (USD)',
  godPromoDuration: 'Duración',
  godPromoDuration_once: 'Una vez',
  godPromoDuration_repeating: 'Repetir',
  godPromoDuration_forever: 'Siempre',
  godPromoMonths: 'Meses (repetir)',
  godPromoValidUntil: 'Válido hasta (opcional)',
  godPromoMaxRedemptions: 'Máx. usos (opcional)',
  godPromoPlans: 'Planes elegibles',
  godPromoPlansHint: 'Si no marcas ninguno, aplica a todos los planes self-serve.',
  godPromoNote: 'Nota interna',
  godPromoSaved: 'Promoción guardada',
  godPromoActive: 'Activa',
  godPromoInactive: 'Inactiva',
  godPromoActivate: 'Activar',
  godPromoDeactivate: 'Desactivar',
  godPromoRedemptions: 'Usos',
  subscriptionPromoCode: 'Código promocional',
  subscriptionPromoPlaceholder: 'SAVE20',
  subscriptionPromoApply: 'Aplicar',
  subscriptionPromoApplied: 'Descuento {discount} · total {total}',
  godBillingAllStatuses: 'Todos los estados',
  godBillingAllPlans: 'Todos los planes',
  godBillingShowArchived: 'Ver archivadas',
  godBillingHideArchived: 'Ocultar archivadas',
  godBillingArchived: 'Archivada',
  godBillingNoSubscriptions: 'Ninguna suscripción coincide con los filtros',
  godBillingReviewQueue: 'Comprobantes por revisar',
  godBillingNoPending: 'No hay comprobantes por revisar',
  godBillingViewProof: 'Ver comprobante',
  godBillingReason: 'Motivo (obligatorio)',
  godBillingReasonRequired: 'Esta acción requiere un motivo',
  godBillingApprove: 'Aprobar',
  godBillingReject: 'Rechazar',
  godBillingGross: 'Procesado',
  godBillingFees: 'Comisiones',
  godBillingCharges: 'Cargos',
  godBillingNoCharges: 'Sin cargos en este periodo',
  godBillingNoEvents: 'Aún no hay eventos de facturación',
  godBillingSubscription: 'Suscripción',
  godBillingCredit: 'Crédito',
  godBillingActions: 'Acciones god',
  godBillingExtendTrial: 'Extender trial 7 días',
  godBillingSetFounder: 'Marcar como fundador',
  godBillingUnsetFounder: 'Quitar fundador',
  godBillingSetExempt: 'Exonerar de facturación',
  godBillingUnsetExempt: 'Quitar exoneración',
  godBillingUnassign: 'Quitar suscripción',
  subscriptionExempt: 'Facturación exonerada — acceso completo',
  godBillingArchive: 'Archivar',
  godBillingRestore: 'Restaurar',
  godConfigTabPlans: 'Paquetes',
  godBillingPlansKicker: 'Precios, cuotas y cuentas de cobro',
  godBillingPlanPrices: 'Precio mensual (USD)',
  godBillingCommercial: 'Parámetros comerciales',
  godBillingExtraHouse: 'Casa extra (USD)',
  godBillingTrialDays: 'Días de trial',
  godBillingFeeBps: 'Comisión de plataforma (bps)',
  godBillingEnforcement: 'Aplicar límites del plan',
  godBillingEnforcementHint: 'Enciéndelo cuando todos los banqueros tengan suscripción.',
  godBillingManualAccounts: 'Cuentas para pago manual',
};
